export default {
  common: {
    bingWallpaper: 'Bing Wallpaper',
    home: 'Startseite',
    about: 'Über uns',
    blog: 'Blog',
    refresh: 'Seite aktualisieren',
    loading: 'Laden...',
    year: '',
    preview: 'Vorschau',
    close: 'Schließen',
    today: 'Heute',
    yesterday: 'Gestern',
    dayBefore: 'Vorgestern',
    daysAgo: 'Tage her',
    monthsAgo: 'Monate her',
    yearsAgo: 'Jahre her',
    unknown: 'Unbekannt',
    copySuccess: 'In die Zwischenablage kopiert',
    copyFail: 'Kopieren fehlgeschlagen, bitte manuell kopieren',
    language: 'Sprache',
    chinese: '中文',
    english: 'English',
    visitorCount: 'Sie sind der {count}. Besucher',
    copyright: 'Alle Bilder auf dieser Website stammen von der Bing-Suche und dienen nur Lern- und Privatzwecken',
    footerCopyright: 'Copyright © 2022 - {year}',
    openMenu: 'Menü öffnen',
    fatalError: 'Seite konnte nicht geladen werden, bitte aktualisieren und erneut versuchen',
    regionChina: 'China',
    regionGermany: 'Deutschland',
    regionCanada: 'Kanada',
    regionUK: 'Großbritannien',
    regionIndia: 'Indien',
    regionUS: 'USA',
    regionFrance: 'Frankreich',
    regionItaly: 'Italien',
    regionJapan: 'Japan',
    netdiskQuark: 'Quark Drive',
    netdiskAlipan: 'Alipan Drive',
    downloadViaNetdisk: 'HD-Wallpaper herunterladen',
    use: 'über'
  },
  wallpaper: {
    siteTitle: 'Bing Wallpaper - Microsoft Bing tägliche HD-Wallpaper zum Download',
    siteDesc: 'Bing Wallpaper Download-Seite. Täglich synchronisieren wir {strong}Microsoft Bing{/strong} offizielle Tageswallpaper. Durchsuchen und laden Sie Bing-Wallpaper aus {strong}China, USA, Japan, Deutschland, Großbritannien, Frankreich, Italien, Kanada, Indien{/strong} und mehr. Unterstützt {strong}4K, 1920x1080, 1920x1200, 1366x768{/strong} und weitere Auflösungen. Filtern nach Jahr und {strong}Massen-Download{/strong} aller Wallpaper. Alle HD-Wallpaper sind kostenlos, perfekt für Desktop- und Handyhintergründe.',
    regionFilter: 'Region',
    resolutionFilter: 'Auflösung',
    yearFilter: 'Jahr',
    selectRegion: 'Region wählen',
    selectResolution: 'Größe wählen',
    selectYear: 'Jahr wählen',
    yearHint: 'Jahr auswählen, um alle Wallpaper aus diesem Jahr als Paket herunterzuladen',
    currentFilter: 'Aktueller Filter',
    totalWallpapers: '{count} Wallpaper',
    batchDownload: 'Massen-Download',
    downloadingWallpapers: 'Wallpaper werden heruntergeladen...',
    packaging: 'Verpacken...',
    downloadSuccess: 'Erfolgreich {count} Wallpaper heruntergeladen',
    downloadFailed: 'Massen-Download fehlgeschlagen, bitte erneut versuchen',
    noWallpapers: 'Keine Wallpaper zum Download verfügbar',
    noResults: 'Keine Wallpaper gefunden, die den Kriterien entsprechen',
    clearFilters: 'Filter zurücksetzen',
    filterRegion: 'Region',
    filterYear: 'Jahr',
    filterResolution: 'Größe',
    fetchFailed: 'Abruf der Wallpaper-Daten fehlgeschlagen',
    fetchFailedNetwork: 'Abruf der Wallpaper-Daten fehlgeschlagen, bitte Netzwerkverbindung prüfen',
    unknownError: 'Unbekannter Fehler',
    yearSuffix: ''
  },
  detail: {
    viewOriginal: 'Original anzeigen',
    backHome: 'Zurück zur Startseite',
    downloadWallpaper: 'Download',
    copyLink: 'Link kopieren',
    viewFullscreen: 'Vollbildansicht',
    fullscreenTooltip: 'Klicken Sie auf das Wallpaper-Bild für die Vollbildansicht',
    imageDescription: 'Beschreibung',
    viewSource: 'Quelle anzeigen',
    openOriginal: 'Original öffnen',
    copyrightInfo: 'Copyright',
    publishDate: 'Datum',
    switchResolution: 'Auflösung wechseln',
    recommended: 'Weitere Wallpaper',
    loadingDetail: 'Wallpaper-Details werden geladen...',
    loadFailed: 'Laden fehlgeschlagen',
    reload: 'Erneut versuchen',
    loadingImage: 'Bild wird geladen...',
    imageLoadFailed: 'Bild konnte nicht geladen werden',
    missingId: 'Wallpaper-ID-Parameter fehlt',
    notFound: 'Wallpaper nicht gefunden',
    fetchDetailFailed: 'Abruf der Wallpaper-Details fehlgeschlagen',
    networkError: 'Netzwerkfehler, bitte Verbindung prüfen und erneut versuchen',
    resolutionSwitched: 'Auflösung gewechselt zu {resolution}',
    startDownload: 'Wallpaper-Download wird gestartet',
    linkCopied: 'Bildlink in die Zwischenablage kopiert',
    setDesktopHint: 'Klicken Sie mit der rechten Maustaste auf das Bild und wählen Sie "Als Desktophintergrund festlegen"',
    alreadyFavorited: 'Dieses Wallpaper wurde bereits favorisiert',
    favoriteSuccess: 'Wallpaper erfolgreich favorisiert',
    copyFailedManual: 'Kopieren fehlgeschlagen, bitte manuell kopieren',
    wechatShareHint: 'Bitte verwenden Sie WeChat zum Scannen und Teilen',
    shareLinkCopied: 'Teilen-Link kopiert',
    sharePrefix: 'Bing Wallpaper: '
  },
  about: {
    title: 'Über Bing Wallpaper',
    subtitle: 'Eine schöne Bing-Wallpaper-Galerie mit umfangreichen Browse-, Filter- und Download-Funktionen.',
    timeline1Title: 'Alle Seiten verbessert',
    timeline2Title: 'Erste Version, grundlegendes Layout fertiggestellt',
    timeline3Title: 'Paginierungs-Anzeige-Bug behoben',
    timeline4Title: 'Komplettes Redesign',
    timeline4Item1: '1. Listenlayout verbessert für bessere Optik und einfachere Bedienung',
    timeline4Item2: '2. Paginierungs-Bug behoben (läuft nicht mehr auf einem Bug!!!)',
    timeline4Item3: '3. Mehrdimensionale Wallpaper-Filterung: Region, Auflösung, Jahr usw.',
    timeline4Item4: '4. Ein-Klick-Massen-Download aller Wallpaper eines gefilterten Jahres',
    frontendProject: 'Frontend-Projekt: ',
    backendProject: 'Backend-Projekt: ',
    backendTutorial: 'Backend-Tutorial: ',
    selfBuildApi: 'Selbstgebaute Bing API',
    postPara1: 'Das Backend verwendet die Dokumentendatenbank {link}MongoDB{/link} zur Datenspeicherung, das unbegrenzte CI/CD-Tool {link2}GitHub Actions{/link2} zum Abrufen täglicher Wallpaper-Daten und Speichern in MongoDB, das Python-Hochleistungs-Async-Framework {link3}FastAPI{/link3} als Backend und {link4}Vercel{/link4} für serverlose Anfrageverarbeitung. Das Frontend verwendet das {link5}Element UI{/link5} Framework für schnelle Entwicklung.',
    postPara2: 'Als ich Bing-Wallpaper entdeckte, sah ich viele großartige Wallpaper auf Bing und wollte eine API für meinen Blog-Hintergrund. Später lernte ich, eine eigene API zu bauen. Dabei lernte ich viel: die pymongo-Bibliothek, FastAPI-Setup, modulares Python-Design; Frontend: Navigationslayout, Icon-Bibliothek-Integration, vue-router, axios-Request-Wrapping, Paginierungsladen.',
    postPara3: 'Es gab auch viele Herausforderungen. Ich suchte ausgiebig und fand, dass die Bing-Wallpaper-API Regionen unterstützt, aber die China-Region wurde zwangsumgeleitet. Bei Vercel dauerte es lange, herauszufinden, wie man Frontend und Backend zusammen hostet. FastAPI hatte viele kleine Fallstricke. Es dauerte lange, bis ich durch Recherche und Studium anderer Designs das modulare Python-Design abschließen konnte. Ich las {link}Element UI{/link} unzählige Male, stieß auf viele Bugs, verstand vue-router anhand der offiziellen Beispiele, und die Paginierung hatte immer noch einen ungelösten Bug — PS: Dieser Bug kann nicht entfernt werden, das Projekt läuft auf ihm.',
    postPara4: '{strong}AI{/strong} ist absolut erstaunlich!!!',
    postPara5: 'Jetzt hat bing-wallpaper das {link}Twikoo{/link} Kommentarsystem integriert. Hinterlassen Sie gerne Ihre Gedanken!'
  },
  seo: {
    siteName: 'Bing Wallpaper',
    defaultTitle: 'Bing Wallpaper | Tägliche HD-Wallpaper | Wallpaper aus der ganzen Welt herunterladen',
    defaultDescription: 'Bing Wallpaper Download-Seite. Bietet Microsoft Bing tägliche HD-Wallpaper, unterstützt Multi-Region- und Multi-Auflösungs-Browsing und -Download.',
    homeTitle: 'Bing Wallpaper | Tägliche HD-Wallpaper | Wallpaper aus der ganzen Welt herunterladen',
    homeDescription: 'Bing Wallpaper Download-Seite. Bietet Microsoft Bing tägliche HD-Wallpaper, unterstützt 9 Regionen: China, USA, Japan, Deutschland, Großbritannien, Frankreich, Italien, Kanada, Indien. Bietet 4K, 1920x1080 und weitere Auflösungen, mit Ein-Klick-Massen-Download aller Jahreswallpaper.',
    regionTitle: 'Regionale Bing-Wallpaper',
    regionDescription: 'Durchsuchen und laden Sie regionale Bing-tägliche HD-Wallpaper. Unterstützt China, USA, Japan, Deutschland, Großbritannien, Frankreich, Italien, Kanada, Indien und mehr.',
    aboutTitle: 'Über uns',
    aboutDescription: 'Bing Wallpaper Website-Vorstellung. Bietet Microsoft Bing tägliche HD-Wallpaper-Downloads, unterstützt Multi-Region- und Multi-Auflösungs-Browsing und -Download. Alle Bilder stammen von der Bing-Suche, nur für Lern- und Privatzwecke.',
    detailTitle: 'Wallpaper-Details',
    detailDescription: 'Bing Wallpaper Detailseite. HD-Wallpaper ansehen und Downloads in mehreren Auflösungen unterstützen.',
    regionSeoTitle: '{name} Bing Wallpaper - {name} tägliche HD-Wallpaper-Download',
    regionSeoDesc: '{name} Bing Wallpaper-Download. Bietet Microsoft Bing {name} regionale tägliche HD-Wallpaper, unterstützt 4K, 1920x1080 und weitere Auflösungen. Kostenloser HD-Desktop-Wallpaper-Download.',
    regionSeoKeywords: '{name} Bing Wallpaper,{name} Wallpaper,Bing Wallpaper,HD Wallpaper Download',
    detailSeoTitle: '{title} - {region} Bing Wallpaper HD Download',
    detailSeoDesc: '{title}. {copyright} Veröffentlicht am {date}{region}. Bing Wallpaper bietet 4K, 1920x1080 und weitere Auflösungen zum kostenlosen Download.',
    detailSeoKeywords: '{title},{region} Bing Wallpaper,HD Wallpaper Download,bing wallpaper,{date}',
    detailSeoKeywordsNoRegion: '{title},Bing Wallpaper,HD Wallpaper Download,bing wallpaper,{date}',
    detailSeoTitleNoRegion: '{title} - Bing Wallpaper HD Download',
    detailSeoFromRegion: ', aus {name}',
    siteJsonLdDesc: 'Bing Wallpaper Download-Seite. Bietet Microsoft Bing tägliche HD-Wallpaper, unterstützt Multi-Region- und Multi-Auflösungs-Browsing und -Download.',
    regionJsonLdDesc: '{name} regionale Bing-tägliche HD-Wallpaper-Download, unterstützt 4K, 1920x1080 und weitere Auflösungen.',
    breadcrumbHome: 'Startseite',
    breadcrumbRegion: '{name} Bing Wallpaper',
    defaultKeywords: 'Bing Wallpaper,tägliche Wallpaper,HD Wallpaper Download,Microsoft Bing,Bing Wallpaper,HD Wallpaper,Desktop Wallpaper,4K Wallpaper,Wallpaper Download',
    htmlTitle: 'Bing Wallpaper | Tägliche HD-Wallpaper | Wallpaper aus der ganzen Welt herunterladen',
    htmlDescription: 'Bing Wallpaper Download-Seite. Bietet Microsoft Bing tägliche HD-Wallpaper, unterstützt 9 Regionen: China, USA, Japan, Deutschland, Großbritannien, Frankreich, Italien, Kanada, Indien. Bietet 4K, 1920x1080 und weitere Auflösungen, mit Ein-Klick-Massen-Download aller Jahreswallpaper.',
    htmlKeywords: 'Bing Wallpaper,tägliche Wallpaper,HD Wallpaper Download,Microsoft Bing,Bing Wallpaper,HD Wallpaper,Desktop Wallpaper,4K Wallpaper,Wallpaper Download,Bing Wallpaper API,Wallpaper Sammlung,tägliche Wallpaper',
    htmlH1: 'Bing Wallpaper - Microsoft Bing tägliche HD-Wallpaper-Download',
    htmlP: 'Bing Wallpaper Download-Seite. Bietet Microsoft Bing tägliche HD-Wallpaper, unterstützt 9 Regionen: China, USA, Japan, Deutschland, Großbritannien, Frankreich und mehr. Unterstützt 4K, 1920x1080 und weitere Auflösungen, mit Ein-Klick-Massen-Download aller Jahreswallpaper.',
    twitterTitle: 'Bing Wallpaper | Tägliche HD-Wallpaper',
    twitterDesc: 'Microsoft Bing tägliche HD-Wallpaper-Download, unterstützt Multi-Region und Multi-Auflösung.'
  }
}



// WEBPACK FOOTER //
// ./src/locale/de-DE.js